<app-dialog-header (backClick)="onNoClick()" [header]="'Modules.NewsItemContentComponent.Header' | translate">
</app-dialog-header>

<div class="dialog-view-wrapper news-container">
  <div class="content">
    <div class="newsitem" id="news">
      <div class="newsimg">
        <div class="newsimg" style="background-image: url({{newsItem.imageUrl}});"></div>
      </div>
      <div class="newstitle">
        <div class="title">{{newsItem.title}}</div>
      </div>
    </div>
    <iframe class="iframe" scrolling="no" [src]="safeSrc" id="myiframe"></iframe> 
  </div>
</div>